import React, { useEffect, useRef, useState } from 'react';
import styles from './Services.module.css';

const images = [
  require("../assets/images/image6.jpeg"),
  // Puedes agregar más imágenes aquí
];

const Services = () => {
  const [index, setIndex] = useState(0);
  const [zoomedIndex, setZoomedIndex] = useState(null); // Guardamos el índice, no la URL
  const intervalRef = useRef(null);

  const next = () => setIndex((prev) => (prev + 1) % images.length);
  const prev = () => setIndex((prev) => (prev - 1 + images.length) % images.length);

  useEffect(() => {
    intervalRef.current = setInterval(next, 3000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleImageClick = (i) => {
    setZoomedIndex(i);
  };

  const closeZoom = () => {
    setZoomedIndex(null);
  };

  const handleKeyDown = (e) => {
    if (zoomedIndex === null) return;

    if (e.key === 'Escape') {
      closeZoom();
    } else if (e.key === 'ArrowRight') {
      setZoomedIndex((prev) => (prev + 1) % images.length);
    } else if (e.key === 'ArrowLeft') {
      setZoomedIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  // Escuchar eventos del teclado solo cuando hay una imagen ampliada
  useEffect(() => {
    if (zoomedIndex !== null) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [zoomedIndex]);

  return (
    <div className={styles.services}>
      <div className="letrero-academico">
        <h1 className={styles.publi}>Publicaciones</h1>
      </div>

      <div className={styles.carruselContainer}>
        <div
          className={styles.carruselInner}
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {images.map((src, i) => (
            <img
              key={i}
              className={styles.elemento}
              src={src}
              alt={`Slide ${i}`}
              onClick={() => handleImageClick(i)}
              style={{ cursor: 'zoom-in' }}
            />
          ))}
        </div>

        <button className={styles.arrowLeft} onClick={prev}>❮</button>
        <button className={styles.arrowRight} onClick={next}>❯</button>
      </div>

      {zoomedIndex !== null && (
        <div className={styles.modalOverlay} onClick={closeZoom}>
          <img
            src={images[zoomedIndex]}
            alt={`Imagen ampliada ${zoomedIndex}`}
            className={styles.modalImage}
          />
        </div>
      )}
    </div>
  );
};

export default Services;
